// extracted by mini-css-extract-plugin
export default {"col":"QuestionSeven_col__wCTq5","infobox":"QuestionSeven_infobox__UVGSI"};